<template>
  <div class="relative px-6 py-3 pb-6 text-dark-type-4">
    <div class>
      <div class="mx-auto font-bold text-center text-dark-type-3">
        Become a shuttler
      </div>
    </div>
    <div class="mt-2">
      <div class="text-xs font-medium text-center">
        Already have an account?
        <router-link to="/login" class="text-active">Login</router-link>
      </div>
    </div>
    <div
      class="flex items-start p-3 my-5 bg-red-200 rounded-md"
      v-if="errorMessage"
    >
      <div class="text-sm font-medium text-red-500">{{ errorMessage }}</div>
    </div>
    <form class="mt-12" @submit.prevent="register">
      <div class="flex flex-wrap -mx-3">
        <div class="w-full px-3 mb-6 md:w-1/2 md:mb-0">
          <label class="text-xs font-medium" for="first-name">First name</label>
          <input
            v-model="$v.form.fname.$model"
            class="
              w-full
              h-12
              px-3
              py-4
              text-xs
              font-medium
              outline-none
              placeholder-label-type-1
              rounded-lg
              border border-solid border-gray-type-9
              focus:outline-none
            "
            type="text"
            id="first-name"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.fname.required && $v.form.fname.$error"
            >Please enter your first name</span
          >
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.fname.validName && $v.form.fname.$error"
          >
            Special characters and numbers are not allowed
          </span>
        </div>
        <div class="w-full px-3 md:w-1/2">
          <label class="text-xs font-medium" for="last-name">Last name</label>
          <input
            v-model="$v.form.lname.$model"
            class="
              w-full
              h-12
              px-3
              py-4
              text-xs
              font-medium
              outline-none
              placeholder-label-type-1
              rounded-lg
              border border-solid border-gray-type-9
              focus:outline-none
            "
            type="text"
            id="last-name"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.lname.required && $v.form.lname.$error"
            >Please enter your last name</span
          >
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.lname.validName && $v.form.lname.$error"
          >
            Special characters and numbers are not allowed
          </span>
        </div>
      </div>
      <div class="mt-6">
        <label class="text-xs font-medium" for="email-address"
          >Email address</label
        >
        <div class="mt-2">
          <input
            v-model="$v.form.email.$model"
            type="email"
            id="email-address"
            class="
              w-full
              h-12
              px-3
              py-4
              text-xs
              font-medium
              outline-none
              placeholder-label-type-1
              rounded-lg
              border border-solid border-gray-type-9
              focus:outline-none
            "
            placeholder="sample@mail.com"
          />
          <span
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.email.required && $v.form.email.$error"
            >Please enter your email address</span
          >
        </div>
      </div>
      <div class="mt-6">
        <label class="text-xs font-medium" for="phone">Phone number</label>
        <div class="mt-2">
          <input
            v-model="$v.form.phone.$model"
            type="text"
            id="phone"
            class="
              w-full
              h-12
              px-3
              py-4
              text-xs
              font-medium
              outline-none
              placeholder-label-type-1
              rounded-lg
              border border-solid border-gray-type-9
              focus:outline-none
            "
            placeholder="0706 111 1198"
          />
          <div
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.phone.required && $v.form.phone.$error"
          >
            Please enter a valid phone number
          </div>
          <div
            class="text-xs font-bold text-red-400"
            v-if="$v.form.phone.phoneNumber && !$v.form.phone.minLength"
          >
            Phone number must be at least
            {{ $v.form.phone.$params.minLength.min }} digits
          </div>
        </div>
      </div>

      <div class="mt-6">
        <label class="text-xs font-medium" for="city">Your City</label>
        <div class="mt-2">
          <select
            class="
              w-full
              h-12
              px-3
              py-4
              text-xs
              font-medium
              outline-none
              placeholder-label-type-1
              rounded-lg
              border border-solid border-gray-type-9
              focus:outline-none
            "
            v-model="form.city_id"
            name="city"
            id="city"
          >
            <option :value="s.city.id" v-for="s in supportedCities" :key="s.id">
              {{ s.city.name }}
            </option>
          </select>
          <div
            class="text-xs font-bold text-red-400"
            v-if="!$v.form.city_id.required && $v.form.city_id.$error"
          >
            Please select a city
          </div>
        </div>
      </div>
      <div class="mt-6">
        <label class="text-xs font-medium" for="password-register"
          >Password</label
        >
        <div class="relative mt-2">
          <input
            v-model="$v.form.password.$model"
            :type="showPassword ? 'text' : 'password'"
            id="password-register"
            class="
              w-full
              h-12
              px-3
              py-4
              text-xs
              font-medium
              outline-none
              placeholder-label-type-1
              rounded-lg
              border border-solid border-gray-type-9
              focus:outline-none
            "
          />
          <div
            class="
              absolute
              inset-y-0
              right-0
              flex
              items-center
              pr-2
              text-xs
              font-medium
              cursor-pointer
              text-active
            "
            @click="showPassword = !showPassword"
          >
            {{ showPassword ? "Hide" : "Show" }}
          </div>
        </div>
        <span
          class="text-xs font-bold text-red-400"
          v-if="!$v.form.password.required && $v.form.password.$error"
          >Please enter a password</span
        >
      </div>
      <button
        type="submit"
        class="
          block
          w-full
          h-12
          py-4
          mt-12
          font-bold
          text-center text-white
          rounded-lg
          focus:outline-none
        "
        :class="processing ? 'bg-gray-type-7' : 'bg-dark-type-1'"
        :dislabed="processing"
      >
        {{ processing ? "Processing..." : "Register" }}
      </button>
      <div class="w-11/12 mx-auto mt-2 text-xs font-medium text-center">
        By clicking on "Register", I have read and agreed to Shuttlers'
        <a :href="termsOfUseLink" target="_blank" class="text-active">Terms of Service</a> and
        <a :href="privacyPolicyLink" target="_blank" class="text-active">Privacy Policy</a>
      </div>
    </form>

    <div class="w-full text-center mt-16">
      <p class="captcha-policy">
        This site is protected by reCAPTCHA and the Google
        <a target="_blank" href="https://policies.google.com/privacy"
          >Privacy Policy</a
        >
        and
        <a target="_blank" href="https://policies.google.com/terms"
          >Terms of Service</a
        >
        apply.
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import { hasRecaptchaKey } from "@/services/utils";
import axios from "@/services/axios";

const phoneNumber = (value) => {
  return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(
    value
  );
};
const validName = (value) => {
  return /^[a-zA-Z]+(([ -][a-zA-Z])?[a-zA-Z]*)*$/.test(value);
};

export default {
  data() {
    return {
      showPassword: false,
      processing: false,
      form: {
        email: "",
        fname: "",
        lname: "",
        phone: "",
        password: "",
        city: null,
      },
      errorMessage: "",
      captchaInitialized: false,
    };
  },
  validations: {
    form: {
      email: {
        required,
      },
      fname: {
        required,
        validName,
      },
      lname: {
        required,
        validName,
      },
      city_id: {
        required,
      },
      phone: {
        required,
        phoneNumber,
        minLength: minLength(11),
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
  },
  created() {
    if (this.supportedCities.length) {
      this.form.city_id = this.supportedCities[0].city.id;
    }

    if (!this.supportedCities.length) {
      this.$store.dispatch("app/fetchSupportedCities");
    }
  },
  async mounted() {
    try {
      await this.$recaptchaLoaded();
      this.captchaInitialized = true;
    } catch (e) {
      console.error(e);
    }
  },
  computed: {
    ...mapGetters("app", ["supportedCities"]),
    ...mapGetters("auth", ["user"]),
    termsOfUseLink() {
      return `${process.env.VUE_APP_WEBSITE_URL}/terms`
    },
    privacyPolicyLink() {
      return `${process.env.VUE_APP_WEBSITE_URL}/privacy-policy`
    }
  },
  methods: {
    async getCaptchaToken() {
      if (hasRecaptchaKey()) {
        try {
          const token = await this.$recaptcha('customer_registration');
          return token;
        } catch (error) {
          console.error("Captcha token error:", error);
          return "";
        }
      } else {
        return "";
      }
    },
    async verifyCaptcha() {
      const token = await this.getCaptchaToken();
      if (this.captchaInitialized && token) {
        return axios.post("/token/captcha/validate", { token });
      } else {
        return Promise.resolve({
          data: {
            success: !hasRecaptchaKey(),
          },
        });
      }
    },
    register() {
      this.$v.form.$touch();
      if (this.processing || this.$v.form.$error) {
        return;
      }
      this.processing = true;
      this.errorMessage = null;
      const payload = { ...this.form };
      this.verifyCaptcha()
        .then((res) => {
          if (res.data.success) {
            return this.$store.dispatch("auth/register", payload);
          } else {
            return this.rejectCaptchaVerification(
              "Captcha Verification Failed!"
            );
          }
        })
        .then(async () => {
          await this.$router.push({
            name: "dashboard.home",
          });
        })
        .catch((err) => {
          if (err.response && err.response.data.message) {
            this.errorMessage = err.response.data.message;
          } else {
            this.errorMessage = "Oops! An error occurred, please try again.";
          }
        })
        .finally(() => (this.processing = false));
    },
    rejectCaptchaVerification(message) {
      return Promise.reject({
        response: {
          data: {
            message,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.captcha-policy {
  @apply sm:max-w-sm max-w-3xl mx-auto font-normal text-label text-xxs;
  a {
    @apply text-green-700;
    text-decoration: none;
    font-weight: 500;
  }
}
</style>